var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Exclamation mark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50017 2.08331C7.9344 2.08331 6.40379 2.54762 5.1019 3.41751C3.80001 4.28741 2.78531 5.52382 2.18612 6.9704C1.58693 8.41698 1.43015 10.0088 1.73562 11.5444C2.04108 13.0801 2.79507 14.4907 3.90224 15.5979C5.0094 16.7051 6.42002 17.4591 7.9557 17.7645C9.49138 18.07 11.0832 17.9132 12.5297 17.314C13.9763 16.7148 15.2127 15.7001 16.0826 14.3982C16.9525 13.0964 17.4168 11.5657 17.4168 9.99998C17.4168 8.96035 17.2121 7.9309 16.8142 6.9704C16.4164 6.00991 15.8332 5.13718 15.0981 4.40205C14.363 3.66692 13.4902 3.08378 12.5297 2.68593C11.5693 2.28808 10.5398 2.08331 9.50017 2.08331ZM9.50017 16.3333C8.24755 16.3333 7.02307 15.9619 5.98155 15.266C4.94004 14.57 4.12828 13.5809 3.64893 12.4236C3.16957 11.2664 3.04415 9.99295 3.28853 8.76441C3.5329 7.53586 4.13609 6.40737 5.02182 5.52164C5.90756 4.6359 7.03605 4.03271 8.2646 3.78834C9.49314 3.54397 10.7666 3.66939 11.9238 4.14874C13.0811 4.6281 14.0702 5.43986 14.7661 6.48137C15.4621 7.52288 15.8335 8.74736 15.8335 9.99998C15.8335 11.6797 15.1662 13.2906 13.9785 14.4783C12.7908 15.6661 11.1799 16.3333 9.50017 16.3333Z",
    fill: "#ff5449"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50017 13.9583C9.93739 13.9583 10.2918 13.6039 10.2918 13.1666C10.2918 12.7294 9.93739 12.375 9.50017 12.375C9.06294 12.375 8.7085 12.7294 8.7085 13.1666C8.7085 13.6039 9.06294 13.9583 9.50017 13.9583Z",
    fill: "#ff5449"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50017 6.04165C9.2902 6.04165 9.08884 6.12505 8.94037 6.27352C8.79191 6.42199 8.7085 6.62335 8.7085 6.83331V10.7916C8.7085 11.0016 8.79191 11.203 8.94037 11.3514C9.08884 11.4999 9.2902 11.5833 9.50017 11.5833C9.71013 11.5833 9.91149 11.4999 10.06 11.3514C10.2084 11.203 10.2918 11.0016 10.2918 10.7916V6.83331C10.2918 6.62335 10.2084 6.42199 10.06 6.27352C9.91149 6.12505 9.71013 6.04165 9.50017 6.04165Z",
    fill: "#ff5449"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warning-red.0d2546b0a6ddb5cbbb0f9f572ebb7fdb.svg";
export { ForwardRef as ReactComponent };